/**
 * Footer sosyal medya ikonları — react-icons/fa6 (brands + genel).
 */
import {
  FaLinkedin,
  FaInstagram,
  FaWhatsapp,
  FaFacebook,
  FaXTwitter,
  FaYoutube,
  FaTiktok,
  FaTelegram,
  FaGithub,
  FaGlobe,
} from 'react-icons/fa6'

/** @type {{ id: string, label: string, Icon: import('react').ElementType }[]} */
export const FOOTER_SOCIAL_ICON_OPTIONS = [
  { id: 'linkedin', label: 'LinkedIn', Icon: FaLinkedin },
  { id: 'instagram', label: 'Instagram', Icon: FaInstagram },
  { id: 'whatsapp', label: 'WhatsApp', Icon: FaWhatsapp },
  { id: 'facebook', label: 'Facebook', Icon: FaFacebook },
  { id: 'x', label: 'X (Twitter)', Icon: FaXTwitter },
  { id: 'youtube', label: 'YouTube', Icon: FaYoutube },
  { id: 'tiktok', label: 'TikTok', Icon: FaTiktok },
  { id: 'telegram', label: 'Telegram', Icon: FaTelegram },
  { id: 'github', label: 'GitHub', Icon: FaGithub },
  { id: 'globe', label: 'Genel (dünya)', Icon: FaGlobe },
]

const ICON_BY_ID = Object.fromEntries(FOOTER_SOCIAL_ICON_OPTIONS.map((o) => [o.id, o.Icon]))
const ALLOWED = new Set(FOOTER_SOCIAL_ICON_OPTIONS.map((o) => o.id))

/** Eski kayıtlarda ikon yoksa sıraya göre varsayılan */
export const FOOTER_SOCIAL_ICON_FALLBACK_ORDER = ['linkedin', 'instagram', 'whatsapp']

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeFooterSocialIconId(raw) {
  const id = String(raw ?? '').trim().toLowerCase()
  if (ALLOWED.has(id)) return id
  return 'globe'
}

/**
 * @param {unknown} iconId
 */
export function resolveFooterSocialIconComponent(iconId) {
  const id = normalizeFooterSocialIconId(iconId)
  return ICON_BY_ID[id] ?? FaGlobe
}
